import React from 'react';

import type { ImageProps } from 'expo-image';
import type { TakeoverPdpHeaderFlairProps } from 'features/app-takeover/types';
import { StyleSheet, View } from 'react-native';

import { FullWidthAutoHeightImage } from 'components/picture';

interface HeaderFlairProps extends TakeoverPdpHeaderFlairProps {
  aspectRatio: number;
  backgroundColor?: string;
  customizationAspectRatio?: number;
  customizationBackgroundColor?: string;
  customizationSource?: ImageProps['source'];
  reviewAspectRatio?: number;
  reviewBackgroundColor?: string;
  reviewSource?: ImageProps['source'];
  source: ImageProps['source'];
}

interface HeaderFlairVariant {
  aspectRatio: number;
  backgroundColor?: string;
  source: ImageProps['source'];
}

const resolveHeaderFlairVariant = ({
  aspectRatio,
  backgroundColor,
  customizationAspectRatio,
  customizationBackgroundColor,
  customizationSource,
  isProductCustomization,
  isProductReview,
  reviewAspectRatio,
  reviewBackgroundColor,
  reviewSource,
  source,
}: HeaderFlairProps): HeaderFlairVariant => {
  const defaultVariant = { aspectRatio, backgroundColor, source };

  if (isProductCustomization && customizationSource != null) {
    return {
      aspectRatio: customizationAspectRatio ?? aspectRatio,
      backgroundColor: customizationBackgroundColor ?? backgroundColor,
      source: customizationSource,
    };
  }

  if (isProductReview && reviewSource != null) {
    return {
      aspectRatio: reviewAspectRatio ?? aspectRatio,
      backgroundColor: reviewBackgroundColor ?? backgroundColor,
      source: reviewSource,
    };
  }

  return defaultVariant;
};

export const HeaderFlair = (props: HeaderFlairProps) => {
  const { aspectRatio, backgroundColor, source } = resolveHeaderFlairVariant(props);

  return (
    <View
      pointerEvents="none"
      style={[styles.container, { backgroundColor }]}
      testID="dragonball-header-flair"
    >
      <FullWidthAutoHeightImage
        source={source}
        style={[styles.image, { aspectRatio }]}
        testID="dragonball-header-flair-image"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    overflow: 'hidden',
  },
  image: {
    position: 'absolute',
    top: 0,
  },
});
